import React from 'react'

export default function BadRequestComponent() {
  return (
    <div>Bad Request</div>
  )
}
